import React, { useState, useEffect } from "react";
import "../styles/mercclienthub.css";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import TrustPilot from "../components/TrustPilot";
import QuestionFormatFaq from "../components/QuestionFormatFaq";
import Footer from "../components/Footer";
// import { initializeTalkdesk } from '../helpers/talkdeskHelper';
import { NavBar } from "../components/NavBar";
import { initializeEmailButton } from "../helpers/emailButtonHelper";

function MercClientHub() {
  const [data, setData] = useState({ questions: [] });

  useEffect(() => {
    initializeEmailButton();
  }, []);

  // function openTalkdesk() {
  // 	window.webchat.open();
  //   }

  const settingsNews = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    arrows: false,
  };

  useEffect(() => {
    const questions = {
      faqHeading: "Frequently asked questions",
      faqs: [
        {
          id: 1,
          label: "What did the Court decide?",
          value:
            "The Court considered whether certain emissions-control systems used by five lead manufacturers: Mercedes-Benz, Ford, Peugeot/Citroen/DS, Nissan and Renault, were unlawful prohibited defeat devices (PDDs).\n\nThe outcome was mixed:\n\n1. One device used by Mercedes-Benz was found to be a PDD.\n2. One device used by Peugeot/Citroen/DS was found to be a PDD.\n3. The Court adopted a narrow interpretation of what amounts to a PDD.\n4. As a result, many of the other devices challenged were not found to be PDDs.\n5. The Court found that the devices alleged against Ford were not defeat devices. Separate issues concerning Ford's emissions-control equipment were not decided at this trial.\n6. The Court indicated that, if its interpretation of the law is wrong, many more of the sample vehicles could contain unlawful defeat devices.\n\nThis was not a final decision on every part of every client's claim. The Judgment itself confirms that the trial covered only part of the liability issues in the wider Litigation.",
        },
        {
          id: 2,
          label: "What happens next for Mercedes claims?",
          value:
            "The Court has ordered that the quantum trial will proceed only against Mercedes. It is currently expected to take place between early November and late December 2026.\n\nThe trial will consider the approach to compensation that may be payable in connection with the Mercedes PDD finding. It does not guarantee that compensation will be awarded or determine the amount any individual claimant may receive.",
        },
        {
          id: 3,
          label: "What happens if my claim is not against Mercedes?",
          value:
            "The quantum trial will not directly determine compensation for claims involving other manufacturers. However, other manufacturers may make limited submissions on legal issues that could affect them. The Court's findings may also provide an indication of how compensation could be approached in non-Mercedes claims.\n\nClaims against the other manufacturers have not been concluded simply because the forthcoming quantum trial concerns Mercedes only.",
        },
        {
          id: 4,
          label: "What does it mean for other manufacturers?",
          value:
            "Claims involving BMW, Fiat/Chrysler/Suzuki, Hyundai-Kia, Jaguar Land Rover, Mazda, Toyota, Vauxhall/Opel, The Volkswagen Group and Volvo were largely placed on hold while the Lead Defendant cases were heard.\n\nThe Judgment may provide legal and factual guidance for those claims, but it does not finally decide every claim against those manufacturers. We are considering how both the Judgment and any appeal affect each group.",
        },
        {
          id: 5,
          label: "What do I need to do following the email I received on 31 July 2026?",
          value:
            "We ask you to confirm that:\n\n1. The Claimant Committee may continue representing your interests.\n2. Pogust Goodhead is instructed to act in connection with any appeal.\n3. If necessary, your Conditional Fee Agreement may be expanded to cover the appeal.\n\nPogust Goodhead would continue acting on the same terms as before. We would also arrange further after-the-event insurance intended to protect you against adverse legal costs. Please use the button in your original email to confirm your agreement.\n\nIf we do not hear from you by 21 August 2026, we will proceed on the basis that you agree and authorise us to continue acting in relation to the appeals.",
        },
        {
          id: 6,
          label: "Will I have to pay the Defendants' legal costs following the appeal?",
          value:
            "The Defendants may seek an order requiring the Claimants to pay some or all of their legal costs arising from the PDD Trial. Any costs consequences following from the Judgment will need to be considered by the Court and/or agreed between the parties.\n\nHowever, as previously explained, After the Event (ATE) insurance is in place to provide protection against adverse costs liabilities, thereby protecting Claimants from being personally responsible for meeting any such costs.\n\nWe are also engaging with the litigation funders and insurers regarding the implications of the Judgment, including the funding and insurance arrangements that would apply should an appeal be pursued. We will provide a further update once those discussions have concluded.\n\nWithdrawing may have different financial consequences from continuing with the claim. As this would breach the terms of your retainer (CFA), the ATE insurance policy may not cover you against the Defendants' costs. However, we cannot confirm at this stage whether you could be responsible for any Defendant's legal costs or other charges if you withdraw now.",
        },
        {
          id: 7,
          label: "What happens if I do not agree to the appeal?",
          value:
            "Your claim will be significantly stronger if the appeal is successful. This would allow us to proceed under the existing terms and secure insurance, which means there would be no downside for you.\n\nIf you decide not to agree with the appeal, you may need to withdraw your claim. This would be against our advice, and could invalidate your After the Event (ATE) insurance, meaning you could become personally liable for the Defendant's costs if they choose to seek them.\n\nWe cannot guarantee whether the Defendant will seek these costs or, if they do, what the total amount would be. Therefore, we strongly advise against this course of action.",
        },
        {
          id: 8,
          label: "What does 'strong grounds' mean that the appeal will succeed, or should I cancel now?",
          value:
            "No outcome can be guaranteed. 'Strong grounds' means that the legal team believes there is a proper and persuasive basis for challenging parts of the decision. It does not mean that permission to appeal or success on the appeal is certain.\n\nIt would not be appropriate to give a percentage chance of success without considering the final appeal grounds and the circumstances of the relevant manufacturer claim.\n\nThe firm's current position is that the relevant parts of the Judgment should be challenged and that the appeal should be pursued. We do not recommend withdrawing solely because of the Judgment or because you believe that your funding arrangements have ended. Please speak to us before making any decision to withdraw so that we can explain the position specific to your claim.",
        },
        {
          id: 9,
          label: "When is the next hearing, and will the appeal delay my claim?",
          value:
            "The 10 July 2026 update indicated that the next hearing was likely to take place in September or October 2026. The exact date and purpose of the hearing should be confirmed in a further update once the Court has formally listed it.\n\nThe appeal is likely to affect the timetable for many claims because its outcome could change the approach applied to the manufacturers. However, the Litigation has not stopped completely. The Court has ordered that the separate quantum trial for the relevant Mercedes vehicles should continue, scheduled for November 2026. Findings from that trial may also provide guidance for other claims.",
        },
        {
          id: 10,
          label: "Am I still on a 'No Win, No Fee' arrangement?",
          value:
            "The appeal does not, by itself, replace the fee arrangement you previously agreed. Our intention is to continue representing clients on the same terms as before.",
        },
      ],
    };
    setData(questions);
  }, []);

  return (
    <>
      <div className="blackBackground">
        <div className="pageWrapper ">
          <NavBar />
        </div>
      </div>

      <div className="flex-container ">
        <div className="">
          <div className="veryLargeText boldText">Pan NOx Emissions Claim</div>
          <div className="largeText">Client Information Hub</div>
          <div className="smallText">England & Wales</div>
          <hr />
          <div className="mediumText">Sign-up Status:</div>
          <div className="mediumText greenText boldText">Closed</div>
          <hr />
          <div className="mediumText">Individual Claims Brought by Pogust Goodhead:</div>
          <div className="mediumText greenText boldText">665,000</div>
          <hr />
        </div>
      </div>

      <div className="flex-container whiteBackground">
        <div className="">
          <div className="title largeText boldText ">Liability Trial (Prohibited Defeat Device)</div>
          <hr />
          <p className="mt20">
            On 10 July 2026, the High Court handed down its Judgment in the PDD Trial. The Court found that three of the 20 sample vehicles contained
            prohibited defeat devices.
          </p>
          <p className="mt20">
            We are seeking permission to appeal aspects of the Judgment, including the Court&apos;s interpretation of the relevant emissions regulations.
          </p>
          <p className="mt20">
            The Quantum Trial, which will consider issues of causation and loss, is now scheduled to begin in November 2026. We will provide further updates
            as the litigation progresses.
          </p>
        </div>
      </div>

      <div className="wrapper lightGreyBackground">
        <div className="largeText boldText">Key Legal Updates</div>
        <div className="regularText">
          We’ve gathered all the key legal updates related to your claim in one place for easy reference. Other new key updates will be added here as well as
          emailed to you.
        </div>
        <div className="regularText">
          Our updates are confidential, intended solely for you and the claimants involved in the litigation, and they are not to be shared publicly.
        </div>
        <div className="legalUpdatesContainer mediumText boldText">
            <div className="legalUpdatesItem">
            <div>August 2026</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/31072026_AllGRUpdateLetter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>July 2026</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/10072026_AlllGRUpdateLetter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>April 2026</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/23.04.2026_DraftAlllGRUpdateLetter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>March 2026</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/other-emissions/02.03.2026_MDCClientUpdate_Letter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>December 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/24.12.2025_AllGRClientUpdateLetter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>November 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/MDC_TrialUpdate_20251126.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>October 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/24.10.2025_AllGRClientUpdat.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>July 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/31.07.2025_AllGRClientUpdate.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>May 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/27.05.25_AllGRClientUpdate_Email.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
          <div className="legalUpdatesItem">
            <div>February 2025</div>
            <a
              className="button boldText"
              href="https://assets.pogustgoodhead.com/documents/Emissions/28.02.25_AllGRClientUpdate.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              VIEW UPDATE
            </a>
          </div>
        </div>
      </div>

      <div className="faqWrapper">
        <QuestionFormatFaq faqs={data.faqs} faqHeading={data.faqHeading} />
      </div>

      <div className="wrapper lightGreyBackground">
        <div>
          <img className="logo" src="https://mydieselclaim.com/wp-content/uploads/2025/01/pg-logo-black-rgb.png" alt="Pogust Goodhead Logo" />
        </div>
        <div>
          Pogust Goodhead is a leading global class action law firm. We are committed to supporting access to justice and holding multinationals to account.
        </div>
        <div>
          <a href="https://pogustgoodhead.com/" className="link boldText" target="_blank" rel="noopener noreferrer">
            Find out more about Pogust Goodhead
          </a>
        </div>
      </div>

      <div className="newsContainer specialContainer news-slick">
        <div className="largeText boldText newsTitle">News</div>
        <Slider {...settingsNews}>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">October 13, 2025</div>
                  <div className="mediumLargeText boldText">Millions Misled, Air Polluted: UK Dieselgate Finally Faces Justice</div>
                  <div className="regularText">
                    The High Court today opens the landmark UK Dieselgate trial (the “Pan NOx PDD Trial”) – one of the largest consumer group action ever heard
                    by the English courts. More than 1.6 million motorists are taking legal action against major car manufacturers, including Mercedes, Ford,
                    Renault, Nissan and Peugeot-Citroën.
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/uk-dieselgate-finally-faces-justice/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img
                  className="newsImage"
                  src="https://pogustgoodhead.com/wp-content/uploads/2024/06/Insights-768-×-507px.jpg"
                  alt="UK Dieselgate Finally Faces Justice"
                />
              </div>
            </div>
          </div>

          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">July 25, 2025</div>
                  <div className="mediumLargeText boldText">
                    High Court blocks attempts by car manufacturers to hide key documents that could show whether they cheated emissions tests
                  </div>
                  <div className="regularText">
                    The High Court has ruled that five car manufacturers at the centre of Dieselgate legal claims must reveal information in hundreds of
                    documents that they claimed were confidential which will be at the heart of a major trial over whether their vehicles cheated emissions
                    tests.
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/dieselgate-high-court-blocks-attempts-by-car-manufacturers-to-hide-key-documents-that-could-show-whether-they-cheated-emissions-tests/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img
                  className="newsImage"
                  src="https://pogustgoodhead.com/wp-content/uploads/2024/06/Insights-768-×-507px.jpg"
                  alt="UK Dieselgate Finally Faces Justice"
                />
              </div>
            </div>
          </div>

          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">November 26, 2024</div>
                  <div className="mediumLargeText boldText">A Significant Ruling From The High Court</div>
                  <div className="regularText">
                    We’re pleased to report a significant ruling from the High Court: the decisions which approve diesel vehicles or updates to them made by the
                    German car regulator, the Kraftfahrt-Bundesamt (KBA), are not binding in English Courts as to the presence or otherwise of prohibited defeat
                    devices in those vehicles.
                  </div>
                  <a className="buttonNews boldText" href="https://pogustgoodhead.com/significant-ruling-high-court/" target="_blank" rel="noopener noreferrer">
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://pogustgoodhead.com/wp-content/uploads/2024/11/Untitled-design-1.jpg" alt="High Court" />
              </div>
            </div>
          </div>

          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">August 16, 2024</div>
                  <div className="mediumLargeText boldText">Post Office Scandal and Emissions</div>
                  <div className="regularText">
                    What do the claimants in our emissions cases have in common with the sub-postmasters affected by the Horizon IT scandal involving the Post
                    Office? Well, more than you might initially think. While each individual’s experience is unique, there are legal..
                  </div>
                  <a className="buttonNews boldText" href="mdcreact/?post-office-scandal-and-emissions=true" target="_blank" rel="noopener noreferrer">
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img
                  className="newsImage"
                  src="https://mydieselclaim.com/wp-content/uploads/2025/01/newspress-collage-qvhuhtybr-1723742930384.webp"
                  alt="Post Office Scandal and Emissions"
                />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">August 6, 2024</div>
                  <div className="mediumLargeText boldText">Latest ‘dieselgate’ case results in Mercedes going to the High Court</div>
                  <div className="regularText">
                    As part of an ongoing legal battle over Mercedes’ emissions scandal, hundreds of thousands of Mercedes drivers are taking the car
                    manufacturer to the High Court on Thursday 9th February. The two-day hearing will be the first time Mercedes has...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://www.lawnews.co.uk/sector-insights/litigation-adr/latest-dieselgate-case-results-in-mercedes-going-to-the-high-court/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img
                  className="newsImage"
                  src="https://mydieselclaim.com/wp-content/uploads/2025/01/pexels-mike-b-120049-1392x782-1.jpg"
                  alt="mercedes headlights"
                />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">August 16, 2024</div>
                  <div className="mediumLargeText boldText">The Emissions Scandal - The Journey So Far</div>
                  <div className="regularText">
                    Where it all began… Our work to provide justice to the millions of people in the UK who were impacted by the Dieselgate emissions scandal
                    started all the way back in 2015. Once Dieselgate broke, we began our landmark litigation...
                  </div>
                  <a className="buttonNews boldText" href="mdcreact/?the-emissions-scandal-the-journey-so-far=true" target="_blank" rel="noopener noreferrer">
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AdobeStock_314734079-1536x907-1.jpeg" alt="fuel pumps" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">August 6, 2024</div>
                  <div className="mediumLargeText boldText">Claimant firms hail ‘turbo charge’ for dieselgate hearings</div>
                  <div className="regularText">
                    Claimants in the ’dieselgate’ group claim against motor manufacturers today hailed a judgment by the president of the King’s Bench Division
                    setting an aggressive court timetable for the action. In Various claimants v Mercedes Benz Group & Ors Dame Victoria Sharp and three...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://www.lawgazette.co.uk/law/claimant-firms-hail-turbo-charge-for-dieselgate-hearings/5118217.article"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/car-exhaust.webp" alt="car exhaust" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">June 14, 2024</div>
                  <div className="mediumLargeText boldText">Emissions cheating case against car industry reveals legal bill to defend action</div>
                  <div className="regularText">
                    Lawyers defending unprecedented legal action against the car industry over emissions cheating have revealed in court the estimated costs of
                    defending the claims are an eye-watering £320 million in legal fees. Claims on behalf of 1.5 million claimants are continuing...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/emissions-cheating-case-against-car-industry-reveals-legal-bill-to-defend-action/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px.jpg" alt="Traffic jam" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">May 2, 2024</div>
                  <div className="mediumLargeText boldText">Group Litigation Orders granted against seven car manufacturers</div>
                  <div className="regularText">
                    Following the latest NOx Emissions Claim hearings, we are pleased to share that seven more Group Litigation Orders (GLOs) have been handed
                    down by the Court. The Group Litigation Orders being granted means that each individual client case will be...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/group-litigation-orders-granted-against-seven-car-manufacturers/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/diesel.png" alt="Diesel cars" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">February 6, 2024</div>
                  <div className="mediumLargeText boldText">Ford to face trial alongside Mercedes for alleged emissions cheating</div>
                  <div className="regularText">
                    Ford will join Mercedes in the first set of car company cases to go to trial over alleged emissions cheating and a suite of manufacturers
                    now face claims after an unprecedented month of action in the High Court. In a...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/ford-to-face-trial-alongside-mercedes-for-alleged-emissions-cheating/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-56.jpg" alt="Exhaust" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">January 18, 2024</div>
                  <div className="mediumLargeText boldText">BMW, Mercedes, and Vauxhall to face legal action in Scotland over emissions scandal</div>
                  <div className="regularText">
                    Thousands of motorists in Scotland have been given the go-ahead today in claims against three major car manufacturers. Over 45,000 claims
                    were granted permission to proceed against BMW, Mercedes and Vauxhall over the emissions scandal. The cases are some of...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/bmw-mercedes-and-vauxhall-to-face-legal-action-in-scotland-over-emissions-scandal/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-50.jpg" alt="bridge" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">January 8, 2024</div>
                  <div className="mediumLargeText boldText">Important information for Mercedes owners</div>
                  <div className="regularText">
                    Have you registered for My Diesel Claim with a Mercedes vehicle? We need your help before 11 January 2024. We’re reaching an important
                    milestone in the Mercedes emissions claim. We must have your information before 11 January so we can...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/important-information-for-mercedes-owners/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Insights-768-×-507px-42.png" alt="Mercedes Badge" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">February 10, 2023</div>
                  <div className="mediumLargeText boldText">Pogust Goodhead stands with Mercedes clients in court over dieselgate scandal</div>
                  <div className="regularText">
                    On Thursday 9 February 2023, Pogust Goodhead stood alongside hundreds of thousands of clients as they faced Mercedes, the billion-pound
                    company, to court in the latest legal battle in the dieselgate scandal. Dieselgate remains one of the biggest corporate scandals...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/pogust-goodhead-stand-with-hundreds-of-thousands-of-mercedes-clients-in-court-over-dieselgate-scandal/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img
                  className="newsImage"
                  src="https://mydieselclaim.com/wp-content/uploads/2025/01/pexels-mike-b-104372-scaled-1-1536x864-1.jpg"
                  alt="mercedes sign"
                />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">July 19, 2021</div>
                  <div className="mediumLargeText boldText">Dieselgate: The VZBZ File Lawsuit Against Mercedes Owners Daimler</div>
                  <div className="regularText">
                    Germany’s largest consumer protection group has filed a lawsuit against Daimler to help Mercedes owners get redress over the Dieselgate
                    scandal. If successful, the lawsuit will set a precedent that would allow Mercedes GLC and GLK car owners to gain...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/dieselgate-the-vzbz-file-lawsuit-against-mercedes-owners-daimler/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Untitled-design-4.png" alt="Pmercedes sign three" />
              </div>
            </div>
          </div>
          <div className="slideCard">
            <div className="flex-container fifty-fifty whiteBackground">
              <div className="left-column">
                <div className="newsItemsLeft">
                  <div className="regularText">September 18, 2020</div>
                  <div className="mediumLargeText boldText">UK Drivers One Step Closer To Receiving Mercedes Compensation</div>
                  <div className="regularText">
                    Mercedes-Benz has agreed to pay £1.7 billion to settle diesel emission cheat claims in the United States, meaning Mercedes UK drivers may be
                    one step closer to getting the compensation they deserve. In a statement, Daimler AG, the parent company...
                  </div>
                  <a
                    className="buttonNews boldText"
                    href="https://pogustgoodhead.com/uk-drivers-one-step-closer-to-receiving-mercedes-compensation/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read more
                  </a>
                </div>
              </div>
              <div className="right-column">
                <img className="newsImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/38.jpg" alt="merc badge close up" />
              </div>
            </div>
          </div>
        </Slider>
      </div>

      {/* <div className="peopleContainer">
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AlisonWebbCol-600x600-1.webp" alt="Alison Webb" />
          <div className="mt10">
            <div className="boldText mediumText">Alison Webb</div>
            <div>Partner</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MatthewNewbouldCol-1-600x600-1.webp" alt="Matthew Newbould" />
          <div className="mt10">
            <div className="boldText mediumText">Matthew Newbould</div>
            <div>Partner</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MichaelBurkeCol-600x600-1.webp" alt="Michael Burke" />
          <div className="mt10">
            <div className="boldText mediumText">Michael Burke</div>
            <div>Partner</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MeganLaffertyCol-600x600-1.webp" alt="Megan Lafferty" />
          <div className="mt10">
            <div className="boldText mediumText">Megan Lafferty</div>
            <div>Partner</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/PriyankaGladsonCol600.png" alt="Priyanka Gladson" />
          <div className="mt10">
            <div className="boldText mediumText">Priyanka Gladson</div>
            <div>Partner</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MatthewHuntCol-600x600-1.webp" alt="Matthew Hunt" />
          <div className="mt10">
            <div className="boldText mediumText">Matthew Hunt</div>
            <div>Legal Director</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/MishaChandnaCol-600x600-1.webp" alt="Misha Chandna" />
          <div className="mt10">
            <div className="boldText mediumText">Misha Chandna</div>
            <div>Senior Associate</div>
          </div>
        </div>
        <div className="peopleItem">
          <img
            className="peopleImage"
            src="https://mydieselclaim.com/wp-content/uploads/2025/01/JoshuaTarrantWindtCol-600x600-1.webp"
            alt="Joshua Tarrant-Windt"
          />
          <div className="mt10">
            <div className="boldText mediumText">Joshua Tarrant-Windt</div>
            <div>Senior Associate</div>
          </div>
        </div>
        <div className="peopleItem">
          <img
            className="peopleImage"
            src="https://mydieselclaim.com/wp-content/uploads/2025/01/Lorcan-treacy-transparent-600x600-1.webp"
            alt="Lorcan Treacy"
          />
          <div className="mt10">
            <div className="boldText mediumText">Lorcan Treacy</div>
            <div>Senior Associate</div>
          </div>
        </div>
        <div className="peopleItem">
          <img className="peopleImage" src="https://mydieselclaim.com/wp-content/uploads/2025/01/Tom-Firth-Jones-v2-600x600-1.webp" alt="Tom Firth-Jones" />
          <div className="mt10">
            <div className="boldText mediumText">Tom Firth-Jones</div>
            <div>Senior Associate</div>
          </div>
        </div>
      </div> */}

      <div className="wrapper lightGreyBackground">
        <div className="largeText boldText">Contact Us</div>
        <div>
          If you can’t find what you’re looking for on this page and need further help with your claim, you can speak to our dedicated emissions care team.
        </div>

        <a className="buttonContact boldText" href="https://pogustgoodhead.com/contact-us/" target="_blank" rel="noreferrer">
          Contact Us
        </a>
        <div>We want to make sure the process is as simple as possible for you. We’re here to help every step of the way.</div>
      </div>

      <div className="specialContainer">
        <TrustPilot />
      </div>

      <div>
        <Footer />
      </div>
    </>
  );
}

export default MercClientHub;
